<template>
	<div class="detail-container">
		<van-image class="detail-background" fit="cover" :src="imgUrl+liveInfo.live_banner_image" />
		<div class="fix detail-bg-onlive">
			<van-image class="fl course-banner-onlive" fit="cover" :src="imgUrl+liveInfo.live_banner_image" />
			<van-row class="fl list-bg-onlive">
				<van-col span="24">
					<div class="list-video-title">{{liveInfo.live_title}}</div>
					<div class="list-video-price">
						<div class="video-price-symbol">¥</div>
						<div class="video-price-num">{{liveInfo.live_price}}</div>
					</div>
					<div class="list-video-time">
						<van-image class="video-time-icon" fit="cover" src="../../../static/images/time.png" />
						<div class="video-time-text">{{liveInfo.live_starttime}}</div>
					</div>
					<div class="list-video-addr">
						<van-image class="video-addr-icon" fit="cover" src="../../../static/images/addr.png" />
						<div class="video-addr-text">{{liveInfo.place}}</div>
					</div>
				</van-col>
			</van-row>
			<van-row class="fl list-bg-onlive">
				<van-col span="24">
					<div class="video-guest-endtime">
						<div class="endtime-title">报名截止时间:</div>
						<div class="endtime-detail">{{liveInfo.enroll_endtime}}</div>
					</div>
					<div class="video-guest-endtime">
						<div class="endtime-title">报名人数上限:</div>
						<div class="endtime-detail">{{liveInfo.number_toplimit}}人</div>
					</div>
					<div class="video-guest-endtime">
						<div class="host-title">主办方:</div>
						<div class="host-detail">{{liveInfo.organizer}}</div>
					</div>
				</van-col>
			</van-row>
			<van-row class="fl list-bg-guest">
				<van-col span="24" class="guest-info-title">讲师介绍</van-col>
				<!-- <van-col span="24" class="guest-info-desc">
					<div class="guest-tx-box">
						<van-image class="guest-tx" fit="cover" :src="imgUrl+lecturer[0].lecturer_image" />
					</div>
					<div class="guest-intro">{{liveInfo.lecturer_synopsis}}</div>
				</van-col> -->
				<van-col span="24" class="guest-single" v-if="lecturer.length == 1" v-for="(item, index) in lecturer" :key="index">
					<div class="guest-headimg">
						<van-image class="guest-tx" fit="cover" :src="imgUrl+item.lecturer_image" />
					</div>
					<div class="guest-rightinfo">
						<div class="lecturer-name">{{item.lecturer_name}}</div>
						<div class="lecturer-zhicheng">{{item.lecturer_title}}</div>
					</div>
				</van-col>
				<van-col span="24" class="guest-more" v-if="lecturer.length > 1">
					<div class="guest-more-item fix" v-for="(item, index) in lecturer" :key="index">
						<div class="fl guest-headimg">
							<van-image class="guest-tx" fit="cover" :src="imgUrl+item.lecturer_image" />
						</div>
						<div class="fr guest-rightinfo">
							<div class="lecturer-name">{{item.lecturer_name}}</div>
							<div class="lecturer-zhicheng">{{item.lecturer_title}}</div>
						</div>
					</div>
				</van-col>
				<van-col span="24" class="guest-info-title guest-desc-title">内容介绍</van-col>
				<van-col span="24" class="guest-desc">
					<div v-html='liveInfo.live_content'></div>
				</van-col>
			</van-row>
		</div>
		<van-image class="toIndex" fit="cover" src="../../../static/images/toindex.png" @click='toIndex' />
		<van-row class="btn-group">
			<van-col span="24">
				<!-- <van-button v-if="liveInfo.button_status == 1" class="onlive-buy-btn" type="default" :disabled="disabled" @click="buyAct">立即支付</van-button> -->
				<div v-if="liveInfo.button_status == 1" class="bottom-common-btn btn-pay" @click="showCoupons">立即支付</div>
				<div v-if="liveInfo.button_status == 3" class="bottom-common-btn btn-pay" @click="goLive">进入直播</div>
				<div v-if="liveInfo.button_status == 4" class="bottom-common-btn btn-pay" @click="goLive">进入回放</div>
				<div v-if="liveInfo.button_status == 2" class="bottom-common-btn btn-end">已报名</div>
				<div v-if="liveInfo.button_status == 0" class="bottom-common-btn btn-end">已结束</div>

			</van-col>
		</van-row>
		<van-row class="buy-alert-container" v-if="isCoupons == true">
			<van-col span="24" class="classbuy-alert-infobox">
				<div class="fix buy-course-line">
					<div class="fl buy-course-leftmark">购买内容</div>
					<div class="fl buy-course-rightinfo">{{liveInfo.live_title}}</div>
				</div>
				<div class="fix buy-course-line">
					<div class="fl buy-course-leftmark">订单金额</div>
					<div class="fl buy-course-rightinfo">￥{{liveInfo.live_price}}</div>
				</div>
				<div class="buy-course-coupons" v-if="radios != null">有效优惠券</div>
				<div class="have-course-coupons-box">
					<div class="radio-box" v-if="radios != null" v-for="(item,index) in radios" :key="item.id">
						<span class="radio" :class="{'on':item.isChecked}"></span>
						<input v-model="payType" :value="item.coupon_par_value" :checked='item.isChecked' class="input-radio" @click="check(index)"
						 type="radio">{{item.coupon_name}}
					</div>
				</div>
				<div class="paidprice" v-if="radios != null">
					<div class="paidprice-text">实付款：</div>
					<div class="paidprice-num">¥{{afterPrice}}</div>
				</div>
				<div class="detail-statu-btn alert-bg-buy-btn">
					<van-button type="default" :disabled="disabled" @click="buyAct">确定</van-button>
				</div>
				<van-image class="closeCoupons" fit="cover" src="../../../static/images/sahnchu.png" @click="closeCoupons" />
			</van-col>
		</van-row>
	</div>
</template>

<script>
	import wxapi from '@/common/wxapi.js'
	export default {
		data() {
			return {
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				//imgUrl: 'http://bsd.mswcy.net',
				liveInfo: '',
				lecturer: [],
				disabled: false,
				onlyCode: '',
				radios: [],
				isCoupons: false,
				salePrice: '', //优惠的价格
				afterPrice: '', //实付价格
				userCouponId: 0,  //用户使用的优惠券id
				userMobile: false  //用户是否绑定手机号
			}
		},
		created() {
			let that = this
			//判断是否授权登录
			if(localStorage.getItem('userId') == null){
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({path: '/author'})
			}			
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
				//每次执行前，先移除上次插入的代码
				document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
				let hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
				hm.id = "baidu_tj";
				let s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
			})();

			let liveID = window.location.href.split('=')[1].replace('&from', '')
			let formdata = new FormData();
			formdata.append('token', localStorage.getItem('token'));
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('live_id', liveID);
// 			formdata.append('token', 'e8cc4453-6c35-40e6-ac7d-279c07bdb452');
// 			formdata.append('user_id', 685);
// 			formdata.append('live_id', 1);
			that.$axios.post('http://sls.zhishen.net.cn/api/Live/liveDeatils', formdata)
				.then(function(res) {
					that.liveInfo = res.data.live_detail
					that.onlyCode = res.data.live_detail.live_code
					that.lecturer = res.data.lecturer
					that.userMobile = res.data.user_mobile
					//修改页面title
					setTimeout(function() {
						document.title = res.data.live_detail.live_title
					}, 100)
					// 分享去除微信默认参数
					if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
						let newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '')
							.replace(/&$|\?$/, '');
						let newUrl = location.origin + location.pathname + newSearch + location.hash;
						location.replace(newUrl);
						let option = {
							title: that.liveInfo.live_title,
							link: newUrl,
							imgUrl: 'http://sl.zhishen.net.cn/static/images/logo.png',
							desc: '读联'
						}
						wxapi.wxRegister(option)
					} else {
						let option = {
							title: that.liveInfo.live_title,
							link: location.href.split('&')[0],
							imgUrl: 'http://sl.zhishen.net.cn/static/images/logo.png',
							desc: '读联'
						}
						wxapi.wxRegister(option)
					}
				}).catch(function(error) {
					console.log(error)
				})
		},
		methods: {
			//回首页
			toIndex() {
				this.$router.push({
					path: '/'
				});
			},
			//点击立即购买弹出优惠信息
			showCoupons() {
				let that = this
				if(that.userMobile == true){
					that.isCoupons = true;
					let formdata = new FormData();
					formdata.append('user_id', localStorage.getItem('userId'));
					formdata.append('token', localStorage.getItem('token'));
					formdata.append('goods_type', 2);
					formdata.append('good_id', location.href.split('&')[0].split('?')[1].split('=')[1]);
					that.$axios.post('http://sls.zhishen.net.cn/api/Usercoupon/qualifiedCoupon', formdata)
					.then(function(res) {
						that.radios = res.data.coupon_list;
						if (that.radios == null) {
							that.afterPrice = that.liveInfo.live_price
							that.userCouponId = 0
						} else {
							that.radios[0].isChecked = true;
							that.userCouponId = that.radios[0].id
							that.afterPrice = parseFloat((that.liveInfo.live_price - that.radios[0].coupon_par_value).toFixed(2));
							if (that.afterPrice < 0) {
								that.afterPrice = 0
							}
						}
					}).catch(function(error) {
						console.log(error)
					})
				}else{
					window.location.href = that.login.pageUrl + '/bindphone?buyUrl='+location.href;
				}
			},
			//选择优惠券
			check(index) {
				var that = this
				//先取消所有选中项
				that.radios.forEach((item) => {
					item.isChecked = false;
				});
				//再设置当前点击项选中
				that.salePrice = that.radios[index].coupon_par_value;
				//用户当前选择的优惠券id
				that.userCouponId = that.radios[index].id
				// 设置值，以供传递
				that.radios[index].isChecked = true;
				//选中优惠券后计算减后价格
				that.afterPrice = parseFloat((that.liveInfo.live_price - that.salePrice).toFixed(2));
				if (that.afterPrice < 0) {
					that.afterPrice = 0
				}
			},
			//关闭优惠信息
			closeCoupons() {
				this.isCoupons = false;
			},
			//立即支付
			buyAct() {
				let that = this;
				that.disabled = true;
				let payData;
				let formdata = new FormData();
				let platform;
				if (window.location.href.indexOf('platform')) {
					platform = that.getUrlParam('platform')
				} else {
					platform = 1
				}
				formdata.append('user_id', localStorage.getItem('userId'));
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('only_code', that.onlyCode);
				formdata.append('goods_type', 2);
				formdata.append('platform', platform);
				formdata.append('user_coupon_id', that.userCouponId)
				that.$axios.post('http://sls.zhishen.net.cn/api/Order/addOrder', formdata)
					.then(function(res) {
						if(res.data.code == 3){
							that.$toast({duration: 1000,message: '购买成功'})
							window.location.reload();
						}
						if(res.data.code == 1){
							payData = res.data.data
							function onBridgeReady() {
								WeixinJSBridge.invoke(
									'getBrandWCPayRequest', {
										"appId": payData.appId, //公众号名称，由商户传入     
										"timeStamp": payData.timeStamp, //时间戳，自1970年以来的秒数     
										"nonceStr": payData.nonceStr, //随机串     
										"package": payData.package,
										"signType": payData.signType, //微信签名方式：     
										"paySign": payData.paySign //微信签名 
									},
									function(res) {
										if (res.err_msg == "get_brand_wcpay_request:ok") {
											// 使用以上方式判断前端返回,微信团队郑重提示：
											//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
											//支付成功刷新页面数据
											window.location.reload();
											console.log('支付成功');
											that.disabled = false;
										} else {
											console.log('支付失败')
											that.disabled = false
										}
									}
								);
							}
							if (typeof WeixinJSBridge == "undefined") {
								if (document.addEventListener) {
									document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
								} else if (document.attachEvent) {
									document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
									document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
								}
							} else {
								onBridgeReady();
							}
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//进入直播
			goLive() {
				let that = this
				//that.$router.push({path: '/liveplayer'});
				window.location.href = that.login.pageUrl + '/liveplayer?liveID=' + that.liveInfo.id
			},
			getUrlParam(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			}
		}
	}
</script>

<style>
	.show {
		display: block !important;
	}

	.hide {
		display: none;
	}

	.list-bg-onlive,
	.detail-background,
	.list-bg-guest,
	.btn-group {
		width: 100%;
	}

	.list-bg-onlive,
	.list-bg-guest {
		background: #fff;
		box-sizing: border-box;
	}

	.list-bg-onlive,
	.list-bg-guest,
	.list-bg-margin,
	.list-item-title {
		margin-top: 2.67vw;
	}

	.list-bg-onlive {
		padding: 5.33vw 4vw;
	}

	.list-bg-onlive,
	.course-banner-onlive .van-image__img,
	.list-bg-guest,
	.guest-info-desc {
		border-radius: 2.67vw;
	}

	.detail-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #f5f7fa;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}

	.detail-background {
		height: 42.13vw;
	}

	.detail-background .van-image__img {
		border-bottom-left-radius: 40px;
		border-bottom-right-radius: 40px;
		-webkit-filter: blur(1px);
		opacity: 4.5;
	}

	.detail-bg-onlive {
		width: 89.34vw;
		height: auto;
		position: absolute;
		top: 5.33vw;
		left: 5.33vw;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
		padding-bottom: 17.34vw;
	}

	.course-banner-onlive {
		width: 100%;
		height: 42.67vw;
	}

	.list-video-title,
	.list-video-price {
		font-weight: bold;
	}

	.list-video-title {
		font-size: 4.8vw;
		color: #222;
		line-height: 6.93vw;
		margin-top: -1.19vw;
	}

	.list-video-price,
	.list-video-time,
	.list-video-addr,
	.video-guest-endtime,
	.btn-group {
		display: flex;
	}

	.list-video-price {
		color: #ff550a;
		align-items: flex-end;
	}

	.list-video-price,
	.list-video-addr,
	.guest-desc {
		margin-top: 4vw;
	}

	.video-price-symbol,
	.video-time-text,
	.video-addr-text,
	.video-guest-name,
	.guest-desc,
	.bottom-common-btn {
		font-size: 4vw;
	}

	.video-price-symbol,
	.video-time-text,
	.video-guest-name {
		line-height: 4vw;
	}

	.video-price-symbol {
		margin-right: 1.34vw;
	}

	.video-price-num {
		font-size: 6.67vw;
		line-height: 6.7vw;
	}

	.list-video-time {
		margin-top: 5.6vw;
	}

	.video-time-icon,
	.video-addr-icon {
		width: 4vw;
		margin-right: 1.6vw;
	}

	.video-time-icon {
		height: 4vw;
	}

	.video-addr-icon {
		height: 4.8vw;
	}

	.video-time-text,
	.video-addr-text,
	.video-guest-title,
	.endtime-title,
	.host-title,
	.contact-title,
	.guest-info-title {
		color: #717784;
	}

	.video-time-text,
	.video-addr-text {
		width: calc(100% - 5.6vw);
	}

	.video-addr-text {
		line-height: 6.13vw;
		margin-top: -1.05vw;
	}

	.video-guest-title,
	.video-guest-zc,
	.video-guest-endtime,
	.guest-info-title,
	.guest-intro {
		font-size: 3.73vw;
	}

	.video-guest-title,
	.video-guest-zc,
	.video-guest-endtime {
		line-height: 3.74vw;
	}

	.video-guest-title {
		padding-bottom: 4vw;
	}

	.video-guest-item,
	.guest-info-title {
		background: #fff6f2;
		border-radius: 1.33vw;
	}

	.video-guest-item {
		padding: 2.67vw 4.27vw 2.67vw 2.67vw;
		margin-bottom: 1.33vw;
	}

	.video-guest-zc {
		color: #999;
		margin-top: 1.86vw;
	}

	.video-guest-endtime {
		margin-top: 4.27vw;
	}

	.endtime-detail,
	.host-detail,
	.contact-detail {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.endtime-title {
		width: 26.14vw;
	}

	.endtime-detail {
		width: calc(100% - 26.14vw);
	}

	.host-title {
		width: 14.94vw;
	}

	.host-detail {
		width: calc(100% - 14.94vw);
	}

	.contact-title {
		width: 18.94vw;
	}

	.contact-detail {
		width: calc(100% - 18.94vw);
	}

	.list-bg-guest {
		padding: 4vw 4vw 5.33vw 4vw;
	}

	.guest-info-title {
		height: 8vw;
		line-height: 8vw;
		text-align: center;
	}

	.guest-info-desc {
		margin-top: 13.87vw;
		background: #f4f5f7;
		padding: 0 2.93vw 4vw 2.93vw;
	}
	
	.guest-single,.guest-more-item{
		padding: 2.93vw;
		box-shadow: 0 0.27vw 1.6vw 0 rgba(0, 0, 0, 0.1);
		border-radius: 1.07vw;
		margin-top: 5.33vw;
		margin-bottom: 5.33vw;
	}
	
	.guest-single{
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.guest-more{
		padding-bottom: 0.1vw;
		overflow: auto;
		white-space: nowrap;
		-webkit-overflow-scrolling : touch;
	}
	
	.guest-more-item{
		width: 52vw;
		margin-left: 1vw;
		margin-right: 3.46vw;
		display: inline-block;
	}
	
	.guest-more .guest-more-item:last-child{
		margin-right: 1vw;
	}

	.guest-tx-box {
		width: 14.4vw;
		height: 14.4vw;
		background: #f4f5f7;
		border: 0.53vw solid rgba(244, 245, 247, 1);
		border-radius: 50%;
		box-shadow: 0px 1px 10px 0px rgba(80, 80, 80, 0.3);
		margin: -8vw auto 0 auto;
	}
	
	.guest-headimg .guest-tx .van-image__img{
		border-radius: 50%;
	}
	
	.guest-headimg{
		width: 10.67vw;
		height: 10.67vw;
	}

	.guest-tx {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		margin: auto;
	}
	
	.guest-rightinfo{
		width: calc(100% - 13.07vw);
	}
	
	.lecturer-name{
		font-size: 4vw;
		color: #222;
		margin-top: 1.06vw;
		line-height: 4vw;
	}
	
	.lecturer-zhicheng{
		font-size: 3.2vw;
		color: #999;
		margin-top: 1.86vw;
		line-height: 3.75vw;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.guest-intro {
		line-height: 5.6vw;
		color: #222;
		margin-top: 2.67vw;
	}

	.guest-desc {
		line-height: 6.67vw;
		text-indent: 2em;
	}

	.guest-desc p {
		clear: both;
	}

	.guest-desc img {
		width: 81.34vw !important;
		float: left;
	}

	.guest-desc p,
	.guest-desc div {
		font-size: 4vw;
		color: #222;
	}

	.btn-group {
		height: 13.34vw;
		background: #fff;
		box-shadow: 0px -1px 16px 0px rgba(5, 5, 5, 0.08);
		position: fixed;
		left: 0;
		bottom: 0;
		justify-content: center;
	}

	.bottom-common-btn,
	.onlive-buy-btn {
		width: 78.67vw;
		height: 9.34vw;
		border-radius: 4.8vw;
		line-height: 9.34vw;
		text-align: center;
		color: #fff;
		margin: 2vw auto;
	}

	.btn-pay,
	.onlive-buy-btn {
		background: linear-gradient(14deg, rgba(251, 76, 76, 1), rgba(254, 108, 0, 1));
	}

	.btn-end {
		background: #ffb696;
	}

	.onlive-buy-btn {
		margin: 2vw 10.665vw;
		border: 0 !important;
	}

	/* 优惠券样式 */
	.radio-box {
		display: inline-block;
		position: relative;
		width: 100%;
		height: 4.8vw;
		line-height: 4.8vw;
	}

	.input-radio {
		display: inline-block;
		position: absolute;
		opacity: 0;
		width: 4.8vw;
		height: 4.8vw;
		cursor: pointer;
		left: 0px;
		outline: none;
		-webkit-appearance: none;
	}

	.radio {
		display: inline-block;
		width: 4.8vw;
		height: 4.8vw;
		vertical-align: middle;
		cursor: pointer;
		background-image: url(../../../static/images/selected.png);
		background-repeat: no-repeat;
		background-size: 4vw 4vw;
	}

	.on {
		background-image: url(../../../static/images/selectedOn.png);
		background-size: 4vw 4vw;
	}

	.buy-alert-container {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		background: rgba(0, 0, 0, 0.4);
		z-index: 12;
		display: flex;
		align-items: center;
	}

	.classbuy-alert-infobox {
		width: 88vw;
		height: auto;
		position: relative;
		background: #fff;
		margin: 0 auto;
		border-radius: 2.66vw;
		padding: 2vw 4vw 6vw;
	}

	.buy-course-line,
	.buy-course-coupons {
		margin-top: 2.66vw;
	}

	.buy-course-leftmark,
	.buy-course-rightinfo {
		line-height: 6.13vw;
	}

	.buy-course-leftmark,
	.paidprice-text {
		width: 21.07vw;
	}

	.buy-course-rightinfo {
		width: calc(100% - 21.07vw);
	}

	.buy-course-coupons {
		line-height: 4.27vw;
	}

	.paidprice {
		display: flex;
		flex-direction: row;
		margin-top: 3.2vw;
	}

	.have-course-coupons-box {
		padding-left: 5.33vw;
		margin-top: 5.33vw;
	}

	.paidprice-text,
	.paidprice-num {
		line-height: 10.66vw;
		color: #212121;
	}

	.paidprice-num {
		font-size: 6.66vw;
		margin-left: 2.66vw;
		font-weight: bold;
	}

	.buyCourse {
		background: linear-gradient(14deg, rgba(251, 76, 76, 1), rgba(254, 108, 0, 1));
		text-align: center;
		font-size: 4.26vw;
		margin: 6vw auto 0 auto;
		border-radius: 5.33vw;
		color: #fff;
		width: 40vw;
		height: 10.66vw;
	}

	.closeCoupons {
		position: absolute;
		top: -3vw;
		right: -3vw;
		width: 6vw;
		height: 6vw;
	}

	.alert-bg-buy-btn {
		margin: 6vw 16vw 0 16vw !important;
	}

	.detail-statu-btn {
		width: 48vw;
		height: 9.34vw;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/view/onlive/detail.vue